import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types/global';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

export interface BrowsingContentThemeProps {
  comparedPortfoliosQuantity: number;
}

const styles: ComponentStylesProps<BrowsingContentThemeProps> = {
  layout: {
    backgroundColor: colors.neutral[100],
    display: 'flex',
  },
  browsingContentWrapper: {
    position: 'relative',
    minHeight: '100vh',
  },
  browsingSpinner: {
    position: 'fixed',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  title: {
    fontSize: '3.4rem',
    lineHeight: '4rem',
    textAlign: 'center',
  },
  cardsList: {
    display: 'grid',
    gap: '3rem',
    maxWidth: '109rem',
    margin: '0 auto',
    gridTemplateColumns: 'repeat(auto-fit, minmax(52.8rem, 1fr))',
    '@media (max-width:1410px)': {
      maxWidth: '80%',
      justifyContent: 'center',
      gridTemplateColumns: 'repeat(auto-fit, minmax(20rem, 52.8rem))',
      transform: 'translateX(2.5rem)',
    },
    [breakpoints.lg.down]: {
      maxWidth: '100%',
      transform: 'none',
      justifyItems: 'stretch',
      justifyContent: 'center',
    },
  },
  browsingCard: {
    // Vertically stretch cards
    display: 'grid',
    gridTemplateRows: 'auto auto 1fr auto',
    height: 'auto',
  },
  browsingContent: {
    margin: '0 2rem 9.6rem',
    '@media (max-width:1410px)': {
      margin: '0 2rem 9.6rem 4rem',
    },
    [breakpoints.lg.down]: {
      margin: '0 2rem 9.6rem',
    },
  },

  browsingHeader: ({ comparedPortfoliosQuantity }) => ({
    maxWidth: '109rem',
    margin: {
      left: 'auto',
      right: 'auto',
      top: '5.6rem',
      bottom: comparedPortfoliosQuantity === 0 ? '6rem' : '2rem',
    },
  }),
  bcBlock: {
    backgroundColor: colors.neutral.white,
    marginBottom: '2.8rem',
    textAlign: 'center',
    maxWidth: '70%',
    width: 'max-content',

    [breakpoints.md.down]: {
      maxWidth: '75%',
      margin: '0px auto 2.8rem',
    },
  },
  portfoliosQuantity: {
    fontSize: '1.6rem',
    maxWidth: '109rem',
    margin: '2rem auto',
    '@media (max-width:1410px)': {
      maxWidth: '50rem',
    },
    [breakpoints.md.down]: {
      textAlign: 'right',
      marginTop: '2rem',
    },
  },
  compareBlock: {
    position: 'sticky',
    top: '0',
    zIndex: '6',
    right: '0',
    left: '25rem',
  },
  backButton: {
    position: 'absolute',
    left: '5%',
    top: '50%',
    transform: 'translateY(-50%)',
    [breakpoints.lg.down]: {
      right: '5%',
      left: '10%',
      top: '-150%',
    },
  },
  openSidebarButton: {
    position: 'absolute',
    top: '-6.6rem', // to center with button in sidebar
    right: '-5%',
    '@media (max-width:1480px)': {
      right: '5%',
    },
  },
  headerTop: {
    position: 'relative',
  },
  hiddenButton: {
    visibility: 'hidden',
  },
  sidebarContentLayout: {
    maxWidth: '100%',
    width: '100%',
  },
  proposalSidebarContent: { width: '25rem' },
  bcModal: {
    maxHeight: '75vh',
    margin: '7vh auto 0px',
    [breakpoints.md.down]: {
      maxWidth: '80%',
      minHeight: '75vh',
    },
  },
  compareButton: {
    textTransform: 'uppercase',
    margin: '0 auto',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
